/** Canonical bounty proof types and helpers. */

export const PROOF_TYPES = [
  "photo",
  "screenshot",
  "link",
  "text",
  "video",
  "document",
  "audio",
] as const;

export type ProofType = (typeof PROOF_TYPES)[number];

/** Normalize legacy DB/UI values to canonical proof type. */
export function normalizeProofType(type: string | null | undefined): ProofType | string {
  if (!type) return "photo";
  if (type === "pdf") return "document";
  return type;
}

export function isFileProofType(type: string | null | undefined): boolean {
  const t = normalizeProofType(type);
  return t === "photo" || t === "screenshot" || t === "video" || t === "document" || t === "audio";
}

export function isImageProofType(type: string | null | undefined): boolean {
  const t = normalizeProofType(type);
  return t === "photo" || t === "screenshot";
}

export const MAX_VIDEO_FILES = 5;
export const MAX_VIDEO_DURATION_SECONDS = 60;

export const PROOF_REJECTION_PRESETS = [
  "Proof is incomplete or missing required details",
  "Proof does not match the bounty requirements",
  "Wrong format or unreadable submission",
  "Quality is too low to verify",
  "Other (see custom message)",
] as const;
